"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _logo = _interopRequireDefault(require("../logo"));
var _excluded = ["href", "isHamburgerNavOpen", "onClick", "setIsHamburgerNavOpen", "tagName", "useBuiltInHamburgerNav", "useMaxWidthLayout"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var GlobalNavLogo = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$href = _ref.href,
    href = _ref$href === void 0 ? '/' : _ref$href,
    isHamburgerNavOpen = _ref.isHamburgerNavOpen,
    _onClick = _ref.onClick,
    setIsHamburgerNavOpen = _ref.setIsHamburgerNavOpen,
    _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'a' : _ref$tagName,
    useBuiltInHamburgerNav = _ref.useBuiltInHamburgerNav,
    useMaxWidthLayout = _ref.useMaxWidthLayout,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // ref applied on a parent div so that margin on child is accounted for when
    // measuring the amount of space the logo takes up
    _react["default"].createElement("div", {
      className: (0, _classnames["default"])({
        'sb-globalNav__logoContainer': useMaxWidthLayout
      }),
      ref: ref
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('sb-globalNav__logo mr3 md-mr4 lg-mr6', {
        'sb-globalNav--maxWidthLogo': useMaxWidthLayout
      })
    }, /*#__PURE__*/_react["default"].createElement(_logo["default"], _extends({
      className: "block",
      href: href,
      onClick: function onClick(e) {
        if (useBuiltInHamburgerNav && isHamburgerNavOpen) {
          setIsHamburgerNavOpen(false);
        }
        _onClick && _onClick(e);
      },
      size: "100%",
      tagName: tagName
    }, otherProps))))
  );
});
GlobalNavLogo.propTypes = {
  isHamburgerNavOpen: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  setIsHamburgerNavOpen: _propTypes["default"].func,
  tagName: _propTypes["default"].any,
  useBuiltInHamburgerNav: _propTypes["default"].bool,
  useMaxWidthLayout: _propTypes["default"].bool
};
var _default = exports["default"] = GlobalNavLogo;